import { type RouteName, routing } from "./routing";

export type { RouteName };

export default routing;
